import { createSelector } from '@ngrx/store'
import { AppState } from '../app.state'
import { LinkingForFundingState } from './for-funding.state'

export const getForFundingState = (state: AppState) => state.linkingForFunding

export const selectForFundingSearchOpen = createSelector(getForFundingState, (state: LinkingForFundingState) => state.isSearchOpen)

export const forFundingIsLoading = createSelector(getForFundingState, (state: LinkingForFundingState) => state.isLoading)

export const forFundingData = createSelector(getForFundingState, (state: LinkingForFundingState) => state.data)

export const downloadForFundingDataIsLoading = createSelector(getForFundingState, (state: LinkingForFundingState) => state.isDownloadLoading)

export const forFundingDataReload = createSelector(getForFundingState, (state: LinkingForFundingState) => state.needReload)

export const forFundingSearchFields = createSelector(getForFundingState, (state: LinkingForFundingState) => state.searchFields)

export const forFundingFundingDetail = createSelector(getForFundingState, (state: LinkingForFundingState) => state.fundingDetail)

export const selectForFundingItemIdToScroll = createSelector(getForFundingState, (state: LinkingForFundingState) => state.itemToScroll)

export const forFundingIsLoadingFundingDetail = createSelector(getForFundingState, (state: LinkingForFundingState) => state.isLoadingFundingDetail)

export const forFundingSoughtPartnerData = createSelector(getForFundingState, (state: LinkingForFundingState) => state.soughtPartnersData)

export const forFundingIsLoadingSoughtPartners = createSelector(getForFundingState, (state: LinkingForFundingState) => state.isLoadingSoughtPartners)
